export enum EFrovSign {
  frov = "frov",
  nonfrov = "nonfrov",
};
